
import { Cookies } from 'react-cookie';


export const requestObject = 
{
      RequestHeader,
     
}
const cookies = new Cookies();
const Token = cookies.get("_AK");
function RequestHeader(requestedFromModule)
{
      const requestOptions = 
      {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': "Bearer "+Token},
          body: JSON.stringify(requestedFromModule)
      };

      return requestOptions;
  
}